import styled from 'styled-components';

export const ResearchProjectStyle = styled.div`
  width: 100%;
  max-width: 1152px;
  padding: 32px 24px 48px;
  color: var(--white);

  @media (min-width: 1024px) {
    padding: 40px 40px 56px;
  }

  .page-header {
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid #262626;

    h1 {
      margin: 0 0 8px;
      font-size: 30px;
      line-height: 36px;
      font-weight: 700;
      color: var(--white);
      text-transform: capitalize;
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 22px;
      color: #a0a0a0;
    }
  }

  .section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;

    h2 {
      margin: 0;
      font-size: 18px;
      line-height: 24px;
      font-weight: 600;
      color: var(--white);
    }

    .add-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
      padding: 10px 16px;
      border: 0;
      border-radius: 8px;
      background: var(--primary);
      color: var(--white);
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .threads {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 80px 24px;
    border-radius: 12px;
    background: #161616;
    border: 1px solid #262626;

    .empty-icon {
      margin-bottom: 16px;
      color: #333;
    }

    p {
      margin: 0;
      font-size: 14px;
      line-height: 22px;
      color: #707070;
    }
  }
`;
